import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const OverlappingCircles: FC<IconSVGComponentProps> = (props) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" fill="none" {...props}>
            <circle cx="7.3" cy="8.3" r="5.55" stroke="currentColor" />
            <circle cx="12.7" cy="11.9" r="5.55" stroke="currentColor" />
        </IconSVG>
    );
};
